(() => {
  if (window.__ncEventBridgeReady) return;
  window.__ncEventBridgeReady = true;

  const approvedEventNames = new Set([
    'service_terms',
    'start_subscription',
    'subscription_add_to_cart',
    'view_model_product',
    'join_kimi_restock',
  ]);

  document.addEventListener('click', (event) => {
    const target = event.target?.closest?.('[data-nc-event]');
    if (!target || !approvedEventNames.has(target.dataset.ncEvent)) return;

    const detail = {
      event_name: target.dataset.ncEvent,
      page_path: location.pathname,
    };

    window.dispatchEvent(new CustomEvent('novcompute:event', { detail }));
  });
})();
